<template>
    <div>
        <!-- Loading Message -->
        <p v-if="!dataLoaded">Loading</p>
        
        <!-- Loaded Data -->
        <div v-if="dataLoaded">
            <button @click="EditMode = !EditMode">Edit</button>
        
            <!-- Edit View -->
            <form v-if="EditMode" v-on:submit.prevent class="SubForm">
                <div class="row">
                    <div class="column">
                        <label>Project Name</label>
                        <input type="text" v-model="project.name">
                        <label>Customer</label>
                        <input type="text" v-model="project.customerName" readonly>
                        <label>Sales Stage</label>
                        <select v-model="project.salesstage"><option v-for="o in $store.salesstages" :value="o.id" :key="o.id">{{o.name}}</option></select>
                        <label>Rating</label><select v-model="project.rating" :value="project.rating"><option value="hot">Hot</option><option value="warm">Warm</option><option value="cold">Cold</option></select>
                        <label>Created:</label><input type="date" v-model="project.created" readonly>
                        <label>Author:</label><input type="text" v-model="project.authorName"><input type="hidden" v-model="project.authorId">
                        <label>Number of Beds:</label><input type="number" v-model="project.num_beds">
                        <label>Number of Apartments:</label><input type="number" v-model="project.num_apartments">
                    </div>
                    <div class="column">
                        <h3>Address</h3>
                        <label>Address 1</label><input type="text" v-model="project.address1" />
                        <label>Address 2</label><input type="text" v-model="project.address2" />
                        <label>Suburb</label><input type="text" v-model="project.locality" />
                        <label>State</label><input type="text" v-model="project.province" />
                        <label>Postcode</label><input type="text" v-model="project.postcode" />
                        <label>Country</label><input type="text" v-model="project.country" />
                    </div>
                </div>
                
                <h3>Notes</h3>
                <textarea v-model="project.notes"></textarea>
                <p><button @click="saveProject">Save Changes</button></p>
            </form>

            <!-- Regular View -->
            <div v-if="!EditMode">
                <div class="row">
                    <div class="column">
                        <h3>{{project.name}}</h3>
                        <p><b>Customer:</b> <router-link :to="'/customers/'+project.customer">{{project.customerName}}</router-link></p>
                        <p><b>Stage: </b> {{project.salesstageName| capitalize}}</p>
                        <p><b>Rating: </b> {{project.rating | capitalize}}</p>
                        <p><b>Created: </b> {{project.created | date}} by <router-link :to="'/users/'+project.authorId">{{project.authorName}}</router-link></p>
                        <p><b>Occupancy: </b>{{project.num_beds}} Beds across {{project.num_apartments}} Apartments</p>
                        <h3>Address</h3>
                        <p>{{project.address1}}<span v-if="project.address2">,</span>{{project.address2}},{{project.locality}} {{project.province}}, {{project.postcode}}, {{project.country}}</p>
                    </div>
                    <div class="column">
                        <h3>Notes:</h3>
                        <p>{{project.notes}}</p>
                    </div>
                </div>

                <hr>
                
                <!-- Add New Interaction Form -->
                <form class="SubForm" v-on:submit.prevent="addInteraction">
                    <input type="hidden" v-model="newInteraction.project">
                    <label>Type</label>
                    <select v-model='newInteraction.type'><option v-for="int in $store.interaction_types" :key="int.id" :value="int.id">{{int.name}}</option></select>
                    
                    <label>Due</label>
                    <input type="date" v-model="newInteraction.due_date" />
                    
                    <label>Completed</label>
                    <input type="checkbox" v-model="newInteraction.completed" />

                    <label>Notes</label>
                    <textarea v-model="newInteraction.content"></textarea>
                    
                    <input type="submit" value="Save"> or <input type="reset">
                </form>

                <!-- Project Interactions -->
                <table>
                    <tr>
                        <th>Record Type</th>
                        <th>Created</th>
                        <th>Due By</th>
                        <th>Status</th>
                        <th>Notes</th>
                    </tr>
                    <tr v-for="int in interactions" :key="int.id">
                        <td>{{int.typeName}}</td>
                        <td>{{int.created | date}} by <router-link :to="'/users/'+int.author">{{int.authorName}}</router-link></td>
                        <td>{{int.due_date |date}}</td>
                        <td>{{int.completed ? 'Completed' : 'Outstanding'}}</td>
                        <td>{{int.content}}</td>
                    </tr>
                </table>
                
            </div>
        </div>
    </div>
</template>

<script>
    // Import Libraries
    import {CallApi} from "../Utilities.js"
    
    export default {
        name: "ProjectDetail",
        data: function() {

            return {
                dataLoaded: false,
                EditMode: false,
                project: {},
                interactions: {},
                newInteraction: {}
            }
        },
        methods: {
            fetchData: async function() {
                const apiResult = await CallApi('GET', `/projects/${this.$route.params.id}`)
                this.project = apiResult.project
                this.interactions = apiResult.interactions
                this.dataLoaded = true
                this.EditMode = false
            },
            addInteraction: async function() {
                const payload = JSON.parse(JSON.stringify(this.newInteraction))
                const apiResult = await CallApi('POST', `/projects/${this.$route.params.id}/interactions`, payload)
                this.interactions.push(apiResult.interaction)
                // Clear our Form for Next Interaction
                this.newInteraction = {}
            },
            saveProject: async function () {
                // Do Update
                await CallApi("POST", `/projects/${this.project.id}`, this.project)
                // Retrieve Updated Data
                this.fetchData()
            }
        },
        mounted: function() {
            this.fetchData()
        }
    }

</script>